// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearArray = function (val: Array<any>) {
  val.splice(0, val.length)
}

export const functions = {
  clearArray,
}

export default functions